//Custom Parsing Add-on Products to Checkout Page when clicking Buy Now Button
document.querySelector('.shopify-payment-button__button--unbranded').addEventListener('click', function(event) {
    event.preventDefault();
    addToCartAndRedirect();
});

document.querySelector('.shopify-payment-button__button--unbranded').addEventListener('touchstart', function(event) {
    event.preventDefault();
    addToCartAndRedirect();
});

async function addToCartAndRedirect() {
    let form = document.querySelector('form[action^="/cart/add"]');
    if (!form) return console.error("Cart form not found!");

    let formData = new FormData(form);

    try {
        let response = await fetch('/cart/add.js', {
            method: 'POST',
            body: formData
        });

        let data = await response.json();
        console.log("Added to cart:", data);

        let cartUpdated = false;
        for (let i = 0; i < 5; i++) { // Retry up to 5 times
            let cartResponse = await fetch(`/cart.js?t=${new Date().getTime()}`);
            let cartData = await cartResponse.json();

            if (cartData.items.length > 1) { 
                cartUpdated = true;
                break;
            }
            await new Promise(resolve => setTimeout(resolve, 500)); 
        }

        if (cartUpdated) {
            setTimeout(() => {
                window.location.href = '/checkout';
            }, 500);
        } else {
            console.error("Cart update failed.");
        }

    } catch (error) {
        console.error("Error adding to cart:", error);
    }
}
